module.exports = __webpack_public_path__ + "img/icon-add.888a4faf.svg";